export default __webpack_public_path__ + "static/media/smartphoneswhite_3.1b7b6165.png";